<p-table [value]="allInvenCategories" dataKey="id" [expandedRowKeys]="expandedRowsCate">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem"></th>
        <th>Name</th>
        <th>Is Active</th>
        <th>Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-expanded="expanded">
      <tr style="background: #f1f1f1;">
        <td>
          <button type="button" [pRowToggler]="product" pButton pRipple
            class="p-button-text p-button-rounded p-button-plain"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            *ngIf="product.childCategory && product.childCategory.length > 0"
            style="width: 20px;height: 20px;"></button>
        </td>
        <td>{{product.name}}</td>
        <td>
          <span *ngIf="product.statusId == statusConstants.INACTIVE">{{answertypeConstants.No}}</span>
          <span *ngIf="product.statusId == statusConstants.ACTIVE">{{answertypeConstants.Yes}}</span>
        </td>
        <td class="action">
          <!-- <span class="btnBars p-mr-0" pTooltip="Add" tooltipPosition="top"
            (click)="showAddChildClass(product)">
            <i class="pi pi-plus"></i></span> -->
          <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"
            (click)="showEditCategory(product)">
            <i class="pi pi-pencil"></i></span>
          <span class="btnBars p-mr-0" pTooltip="Delete" (click)="checkAssociateProduct(product,categoryConstants.parentType)"
            tooltipPosition="top"><i class="pi pi-trash"></i></span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-product>
      <ng-container *ngFor="let child of product.childCategory">
        <tr>
          <td style="padding-left: 2rem !important;">
            <button type="button" pButton pRipple
              (click)="child.toggle=!child.toggle;child.subExpanded=!child.subExpanded"
              class="p-button-text p-button-rounded p-button-plain"
              [icon]="child.subExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              *ngIf="child.childCategory && child.childCategory.length > 0"
              style="width: 20px;height: 20px;"></button>
          </td>
          <td style="padding-left: 2rem !important;">{{child.name}}</td>
          <td>
            <span *ngIf="child.statusId == statusConstants.INACTIVE">{{answertypeConstants.No}}</span>
            <span *ngIf="child.statusId == statusConstants.ACTIVE">{{answertypeConstants.Yes}}</span>
          </td>
          <td class="action">
            <!-- <span class="btnBars p-mr-0" pTooltip="Add" tooltipPosition="top"
              (click)="showAddCategory(product,child)"><i class="pi pi-plus"></i></span> -->
            <span class="btnBars p-mr-0" (click)="showEditCategory(child,categoryConstants.childType)" pTooltip="Edit"
              tooltipPosition="top"><i class="pi pi-pencil"></i></span>
            <span class="btnBars p-mr-0" (click)="checkAssociateProduct(product,categoryConstants.childType,child)"
              pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
          </td>
        </tr>
        <ng-container *ngIf="child.toggle">
          <ng-container *ngFor="let sub of child.childCategory">
            <tr>
              <td style="padding-left: 4rem !important;">
                <button type="button" pButton pRipple
                  (click)="sub.toggle=!sub.toggle;sub.subExpanded=!sub.subExpanded"
                  class="p-button-text p-button-rounded p-button-plain"
                  [icon]="sub.subExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  *ngIf="sub.childCategory && sub.childCategory.length > 0"
                  style="width: 20px;height: 20px;"></button>
              </td>
              <td style="padding-left: 3rem !important;">{{sub.name}}</td>
              <td>
                <span *ngIf="sub.statusId == statusConstants.INACTIVE">{{answertypeConstants.No}}</span>
                <span *ngIf="sub.statusId == statusConstants.ACTIVE">{{answertypeConstants.Yes}}</span>
              </td>
              <td class="action">
                <span class="btnBars p-mr-0" (click)="showEditCategory(sub,categoryConstants.subChildType)"
                  pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                <span class="btnBars p-mr-0" (click)="checkAssociateProduct(product,categoryConstants.subChildType,child,sub)"
                  pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
              </td>
            </tr>
            <ng-container *ngIf="sub.toggle">
              <tr *ngFor="let subb of sub.childCategory">
                <td></td>
                <td style="padding-left: 3rem !important;">{{subb.name}}</td>
                <td>
                  <span *ngIf="subb.statusId == statusConstants.INACTIVE">{{answertypeConstants.No}}</span>
                  <span *ngIf="subb.statusId == statusConstants.ACTIVE">{{answertypeConstants.Yes}}</span>
                </td>
                <td class="action">
                  <span class="btnBars p-mr-0" (click)="showEditCategory(subb,categoryConstants.childSubChildType)"
                    pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                  <span class="btnBars p-mr-0" (click)="checkAssociateProduct(product,categoryConstants.childSubChildType,child,sub,subb)"
                    pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-template>
  </p-table>

  <p-dialog header="{{addEditCategoryHeader}}" [modal]="true" [(visible)]="displayAddEditCategory"
  [style]="{width: '50vw'}" [baseZIndex]="10000" (onHide)="inventoryCategoryForm.reset();isChildCatEdit=false;isSubChildCatEdit=false;isParentCatEdit=false;">

  <form [formGroup]="inventoryCategoryForm">
    <div class="header">
      <h5>Category Information
        <p-inputSwitch class="header-switch" formControlName="statusId" (onChange)="checkCategoryProduct()"></p-inputSwitch>
      </h5>
    </div>
    <div class="card">
      <div class="p-grid">
        <div class="p-col-6">
          <label for="name">Name<span style="color: red;">*</span></label>
          <input type="text" pInputText formControlName="name">
          <small *ngIf="invalidData" class="p-invalid">
            Name exists in the list already
          </small>
        </div>
        <div class="p-col-6" *ngIf="!isChildCatEdit && !isSubChildCatEdit && !isChildSubChildCatEdit">
          <label for="name">Sub-Category</label>
          <p-treeSelect class="border-bottom-input" [options]="allInvenCateDropdown" appendTo="body"
          display="comma" [metaKeySelection]="false" formControlName="parentCategoryId"
          selectionMode="single" placeholder="Select Item" [disabled]="isParentCatEdit"></p-treeSelect>
        </div>
        <div class="p-col-6" *ngIf="isChildCatEdit">
          <label for="name">Sub-Category</label>
          <p-dropdown appendTo="body" optionLabel="name"  [options]="allInvenCategories" [ngModelOptions]="{standalone: true}"
            formControlName="parentCategoryId" [disabled]="isChildCatEdit" placeholder="Select Item">
          </p-dropdown>
        </div>
        <div class="p-col-6" *ngIf="isSubChildCatEdit">
          <label for="name">Sub-Category</label>
          <p-dropdown appendTo="body" optionLabel="name"  [options]="selectedCategory.childCategory" [ngModelOptions]="{standalone: true}"
            formControlName="parentCategoryId" [disabled]="isSubChildCatEdit" placeholder="Select Item">
          </p-dropdown>
        </div>
        <div class="p-col-6" *ngIf="isChildSubChildCatEdit">
          <label for="name">Sub-Category</label>
          <p-dropdown appendTo="body" optionLabel="name"  [options]="selectedCategory.childCategory" [ngModelOptions]="{standalone: true}"
            formControlName="parentCategoryId" [disabled]="isChildSubChildCatEdit" placeholder="Select Item">
          </p-dropdown>
        </div>
      </div> 
      <!-- <div class="p-grid">
        <div class="p-col-6" *ngIf="!isChildCatEdit && !isSubChildCatEdit && !isChildSubChildCatEdit">
          <label for="name">Sub-Category</label>
          <p-treeSelect class="border-bottom-input" [options]="allInvenCateDropdown" appendTo="body"
          display="comma" [metaKeySelection]="false" formControlName="parentCategoryId"
          selectionMode="single" placeholder="Select Item" [disabled]="isParentCatEdit"></p-treeSelect>
        </div>
        <div class="p-col-6" *ngIf="isChildCatEdit">
          <label for="name">Sub-Category</label>
          <p-dropdown appendTo="body" optionLabel="name"  [options]="allInvenCategories" [ngModelOptions]="{standalone: true}"
            formControlName="parentCategoryId" [disabled]="isChildCatEdit" placeholder="Select Item">
          </p-dropdown>
        </div>
        <div class="p-col-6" *ngIf="isSubChildCatEdit">
          <label for="name">Sub-Category</label>
          <p-dropdown appendTo="body" optionLabel="name"  [options]="selectedCategory.childCategory" [ngModelOptions]="{standalone: true}"
            formControlName="parentCategoryId" [disabled]="isSubChildCatEdit" placeholder="Select Item">
          </p-dropdown>
        </div>
        <div class="p-col-6" *ngIf="isChildSubChildCatEdit">
          <label for="name">Sub-Category</label>
          <p-dropdown appendTo="body" optionLabel="name"  [options]="selectedCategory.childCategory" [ngModelOptions]="{standalone: true}"
            formControlName="parentCategoryId" [disabled]="isChildSubChildCatEdit" placeholder="Select Item">
          </p-dropdown>
        </div>
        <div class="p-col-6">
          <label for="name">Type</label>
          <p-dropdown appendTo="body" [options]="allInvenCateDropdown"  [ngModelOptions]="{standalone: true}"
            [(ngModel)]="selectedInvenCategory" [group]="true">
          </p-dropdown>
        </div>
      </div> -->
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button pButton (click)="closeAddEditCategory()" label="Cancel" class="p-button-secondary"></button>
    <button pButton [disabled]="!inventoryCategoryForm.valid" (click)="addEditCate(inventoryCategoryForm.value)"
      label="Save"></button>
  </ng-template>
</p-dialog>

  <p-dialog header="{{action=='delete' ? 'Delete' : 'InActive'}} Category" [(visible)]="displayProductAvailability" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}">
    <div class="header">
      <h5>{{action=='delete' ? 'Delete' : 'InActive'}} Warning</h5>
    </div>
    <div class="card">
      <span style="font-weight: bold;">This Category is associated with below Multiple Products</span><br>
      <span>{{associatedProducts}}</span>
    </div>
  </p-dialog>

<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
